import { ActivityActions, ActivityActionTypes, ActivityState } from './types';

export const defaultState = (): ActivityState => ({
  showAffirmation: false,
  activity: {
    book: null,
    characters: [],
    title: '',
    description: '',
    type: '',
    url: '',
  },
});

export const reducers = (state: ActivityState, action: ActivityActions): ActivityState => {
  switch (action.type) {
    case ActivityActionTypes.SET_ACTIVITY:
      return { ...state, ...{ activity: action.payload } };
    case ActivityActionTypes.SET_SHOW_AFFIRMATION:
      return { ...state, ...{ showAffirmation: action.payload } };
    default:
      return { ...state };
  }
};
